import React from 'react';
import { withTranslation } from "react-i18next";
import classNames from "classnames";
import "./index.scss";

import Waiter from "../Waiter/Waiter";
import EditButtonsBlock from "./EditButtonsBlock";
import TimeBox from "../TimeBox/TimeBox";
import ConfirmCombo from "../ConfirmCombo";

import {
    ORDER_STATE,
    WAITER_TYPES,
    CONFIRM_DIALOG_TYPE,
    getCurrencyIcons,
    getExternalCourierProviderNameByProvider
} from "../../../utils/enums";
import { getStaticTime } from "../../../utils/convertTime";
import {defaultPromiseResolve, isEmpty} from "../../../utils/objects-util";
import { isAllowOrderDeleteWithoutPassword } from "../../../services/restaurant";
import { getFormattedDeliveryDuration, getOrderArrivalEstimation } from "../../../services/order";
import { isRTL, getCourierNameById, isExistStatusDelivery, getConfirmUsers } from "../../../services/userModel";
import { getAppartmentNumber } from '../../../services/order';

import IconButton from "../IconButton";
import OrderTitleInfo from "../OrderTitleInfo";

const ActiveOrderInfo = ({
  t,
  showOrdersMore,
  item,
  users,
  orders,
  user,
  isAssistanceOrder,
  isEditDelivery,
  courierConfirmDialogType,
  userInfoItem,
  convertedTargetTime,
  showConfirmDialog,
  isWithPassword,
  getOrderStatusLabeltext,
  getIsShowAssociate,
  getIsShowReady,
  handleOnConfirmDialog,
  handleOnChangeOrderState,
  handleOpenAssociatePopup,
  handleOnCancelConfirmDialog,
  handleOnEdit,
  getIsShowPickedUp,
  handleOnShowConfirmDialog,
  handleOnPreviewClick,
  handleOnShowOrdersMore,
  handleApplyCourierDelivery,
  handleOnEditDelivery,
  getProviderById,
}) => {
  const isShowETAForOrder = () => {
    return user &&
      user.cycle &&
      item.state <= ORDER_STATE.onroute;
  };

  return (
    <div className={classNames("userInfoItems")}>
      <div className={classNames("userInfoItemColumn", "userInfo", { assistance: isAssistanceOrder })}>
        {userInfoItem(
          <div className={classNames("titleBlock")}>
            <div className={classNames("userNameContainer")}>
              <OrderTitleInfo order={item} isWithId />
              {getAppartmentNumber(item) && (
                <span> {t("dashboard.orders.APPARTMENT")}:&nbsp;{getAppartmentNumber(item)}</span>
              )}
            </div>
            <span className={classNames("info")}>
              {item.isHighPriority && (<IconButton isIcon={true} iconName="crown" onClick={defaultPromiseResolve} />)}
              &nbsp;
              {item.notes && <span className={classNames("notes")}>{item.notes || "-"}</span>}
            </span>          
          </div>,
          <div className={classNames("lineBlock")}>
            {item.state < 4 && (
              <div>
                <div className={classNames("time")}>{t("orders.TARGET_TIME_LABEL")}:</div>
                <div className={classNames("time")}>
                  {convertedTargetTime ? convertedTargetTime : t("orders.ASAP_LABEL")}
                </div>
              </div>
            )}
          </div>,
          "noBorder"
        )}
        {userInfoItem(
          <div className={classNames("footerAction")}>
            <div className={classNames("link")} onClick={handleOnShowOrdersMore}>
              {t("orders.CONTENTS_MORE")}
            </div>
          </div>,
          <div className={classNames("status")}>
            {item.state === ORDER_STATE.delivered && (
              <div className={classNames("deliveryBy")}>
                <IconButton isIcon={true} 
                  iconName={"orderEdit"} 
                  tooltipText={t("dashboard.orders.EDIT_ORDER_DELIVERY")}
                  onClick={handleOnEditDelivery} 
                />
              </div>
            )}
            {item.state === ORDER_STATE.delivered && (
              <div className={classNames("statusItem")}>
                <span className={classNames("statusLabel")}>{t("orders.DELIVERED_BY_LABEL")}:&nbsp;</span>
                {!isEditDelivery && (
                  <span>
                      {item.deliveryProviderId ? (
                          getProviderById(item.deliveryProviderId)?.name
                      ) : (
                          <>
                              {item && !isEmpty(item.deliveryProvider) && getExternalCourierProviderNameByProvider(item.deliveryProvider)}
                              {item && isEmpty(item.deliveryProvider) && (getCourierNameById(item.deliveryBy) || "-")}
                          </>
                      )}
                  </span>
                )}
                {isEditDelivery && (
                  <ConfirmCombo
                    values={getConfirmUsers(users)}
                    comboKey="userId"
                    comboValueField={["firstName", "lastName"]}
                    onApply={handleApplyCourierDelivery}
                    onCancel={handleOnEditDelivery}
                  />
                )}
              </div>
            )}
            {!isAssistanceOrder && (
              <div className={classNames("statusItem")}>
                <span className={classNames("statusLabel")}>
                  {t("orders.STATUS_LABEL")}
                  :&nbsp;
                </span>
                <span>{getOrderStatusLabeltext()}</span>
              </div>
            )}
            {isExistStatusDelivery(item) && (
              <div className={classNames("statusItem")}>
                <span className={classNames("statusLabel")}>
                  {t("orders.COURIER_GROUP_LABEL")}
                  :&nbsp;
                </span>
                <span className={classNames("statusValue")}>
                  {getCourierNameById(item.groupId)}
                </span>
              </div>
            )}
          </div>,
          "toBottom"
        )}
      </div>
      <div className={classNames("userInfoItemColumn", "order", { assistance: isAssistanceOrder })}>
        {userInfoItem(
          <div className="receiveLabel">
            {t("orders.RECEIVED_AT_LABEL")}:&nbsp;{getStaticTime(item.date, false, isRTL())}
            {isShowETAForOrder() && (
              <div>
                {t("orders.ETA_LABEL")}
                :&nbsp;
                {getOrderArrivalEstimation(item, user, (orders || []).filter(f=> user && f.groupId === user.userId))}
              </div>
            )}
          </div>,
          <div className={classNames("receiveLabel")}>
            <TimeBox date={item.date} />
          </div>,
          "noBorder"
        )}
        {item &&
          item.deliveryBy &&
          item.state === ORDER_STATE.delivered &&
          userInfoItem(
            <div className={classNames("titleBlock")}>
              {t("orders.DELIVERED_AT_LABEL")}
              :&nbsp;
              {getStaticTime(item.deliveryTime, false, isRTL())}
            </div>,
            <div className={classNames("titleBlock")}>
              {t("orders.DELIVERY_DURATION_LABEL")}
              :&nbsp;
              {getFormattedDeliveryDuration(item)}
            </div>,
            "toBottom responsiveBottom"
          )}
      </div>
      <div
        className={classNames("userInfoItemColumn", "payment", {
          assistance: isAssistanceOrder
        })}
      >
        {userInfoItem(
          <div className={classNames("titleBlock")}>
            <div>{t("orders.PAYMENT_LABEL")}</div>
            <div />
          </div>,
          <div />,
          "noBorder"
        )}
        {userInfoItem(
          <div className={classNames("titleBlock")}>
            {t("dashboard.orders.TOTAL_LABEL")}
          </div>,
          <div className={classNames("titleBlock")}>{`${
            item.amount || 0
          } ${getCurrencyIcons(item.currency)}`}</div>,
          "toBottom"
        )}
      </div>
      <div className={classNames("userInfoItemColumn", "orderStatus", { assistance: isAssistanceOrder })}>
        <div className={classNames("orderStatusControl")}>
          {item.state === ORDER_STATE.new && !isAssistanceOrder && (
            <Waiter
              tooltipText={t("orders.KITCHEN_BUTTON")}
              useWrapClass={classNames(
                "controlAction",
                "canceled",
                "rightDirection"
              )}
              useTextClass="action-description"
              useSvg="#icon-pan"
              useSvgClass={classNames("actionIcon", "order-kitchen")}
              spanText={t("orders.KITCHEN_BUTTON")}
              type={WAITER_TYPES.buttonSpan}
              handleOnClick={() => handleOnChangeOrderState(item.state + 1)}
              stopPropagation={true}
            />
          )}
          {item.state === ORDER_STATE.kitchen && !isAssistanceOrder && (
            <Waiter
              tooltipText={t("orders.DELIVERY_BUTTON")}
              useWrapClass={classNames("controlAction", "canceled")}
              useTextClass="action-description"
              useSvg="#icon-arrow-right"
              useSvgClass={classNames("actionIcon", "arrowRightIcon", "pin")}
              spanText={t("orders.DELIVERY_BUTTON")}
              type={WAITER_TYPES.buttonSpan}
              handleOnClick={() => handleOnChangeOrderState(item.state + 1)}
              stopPropagation={true}
            />
          )}
          {item.state === ORDER_STATE.ready && getIsShowAssociate && !isAssistanceOrder && (
              <Waiter
                tooltipText={t("orders.ASSOCIATE_BUTTON")}
                useWrapClass={classNames(
                  "controlAction",
                  "canceled",
                  "ready",
                  "rightDirection"
                )}
                useTextClass="action-description"
                useSvg="#icon-arrow-right"
                useSvgClass={classNames("actionIcon", "arrowRightIcon", "pin")}
                spanText={t("orders.ASSOCIATE_BUTTON")}
                type={WAITER_TYPES.buttonSpan}
                handleOnClick={handleOpenAssociatePopup}
                stopPropagation={true}
              />
            )}
          {item.state === ORDER_STATE.ready && getIsShowPickedUp && (
            <Waiter
              tooltipText={t("orders.PICKED_UP_BUTTON")}
              useWrapClass={classNames("controlAction", "canceled", 'pickedup')}
              useTextClass="action-description"
              useSvg="#icon-arrow-top"
              useSvgClass={classNames("actionIcon", "arrowRightIcon", "pin")}
              spanText={t("orders.PICKED_UP_BUTTON")}
              type={WAITER_TYPES.buttonSpan}
              handleOnClick={() => handleOnChangeOrderState(4)}
              stopPropagation={true}
            />
          )}
          {item.state === ORDER_STATE.ready && getIsShowReady && !isAssistanceOrder && (
              <Waiter
                tooltipText={t("orders.READY_LABEL")}
                useWrapClass={classNames("controlAction")}
                useTextClass="action-description"
                useSvg="#icon-check"
                useSvgClass={classNames("actionIcon")}
                spanText={t("orders.READY_LABEL")}
                type={WAITER_TYPES.buttonSpan}
                handleOnClick={() => {
                  return new Promise(resolve => {
                    resolve();
                  });
                }}
                stopPropagation={true}
                disabled={true}
              />
            )}
          {item.state === ORDER_STATE.onroute && !isAssistanceOrder && (
            <Waiter
              tooltipText={t("orders.DISPATCHED_BUTTON")}
              useWrapClass={classNames("controlAction")}
              useTextClass="action-description"
              useSvg="#icon-check"
              useSvgClass={classNames("actionIcon")}
              spanText={t("orders.DISPATCHED_BUTTON")}
              type={WAITER_TYPES.buttonSpan}
              handleOnClick={() => {
                return new Promise(resolve => {
                  resolve();
                });
              }}
              stopPropagation={true}
              disabled={true}
            />
          )}
          {item.state === ORDER_STATE.delivered && !isAssistanceOrder && (
            <Waiter type={WAITER_TYPES.buttonSpan}
              tooltipText={t("orders.DELIVERED_BUTTON")}
              useWrapClass={classNames("controlAction")}
              useTextClass="action-description"
              useSvg="#icon-check"
              useSvgClass={classNames("actionIcon")}
              spanText={t("orders.DELIVERED_BUTTON")}
              stopPropagation={true}
              disabled={true}
              handleOnClick={() => new Promise(resolve => resolve())}
            />
          )}
          {item.state === ORDER_STATE.canceled && !isAssistanceOrder && (
            <Waiter type={WAITER_TYPES.buttonSpan}
              tooltipText={t("orders.CANCELED_BUTTON")}
              useWrapClass={classNames("controlAction", "closed")}
              useTextClass="action-description"
              spanText={t("orders.CANCELED_BUTTON")}            
              handleOnClick={() => new Promise(resolve => resolve())}
              stopPropagation={true}
              disabled={true}
            />          
          )}
          {showOrdersMore && isAssistanceOrder && (
              <div className={classNames("receiveLabel")}>
                <TimeBox date={item.date} />
              </div>
            )}
        </div>
        <EditButtonsBlock 
          id={item.id}
          orderState={item.state}
          serviceNotes={item.serviceNotes}  
          showConfirmDialog={showConfirmDialog}
          isWithPassword={isWithPassword}
          isAssistanceOrder={isAssistanceOrder}
          courierConfirmDialogType={courierConfirmDialogType}
          handleOnConfirmDialog={handleOnConfirmDialog}
          handleOnCancelConfirmDialog={handleOnCancelConfirmDialog}
          handleOnEdit={handleOnEdit}
          handleOnDeleteClick={() =>
            handleOnShowConfirmDialog(
              CONFIRM_DIALOG_TYPE.deleteItem,
              !isAllowOrderDeleteWithoutPassword()
            )
          }
          handleOnPreviewClick={handleOnPreviewClick}
          handleOnRevertClick={() =>
            handleOnShowConfirmDialog(CONFIRM_DIALOG_TYPE.reload, false)
          }
          handleOnChangeOrderState={handleOnChangeOrderState}
        />
      </div>
    </div>
  );
}

export default withTranslation()(ActiveOrderInfo);
